import { render, staticRenderFns } from "./StarSolidTopBarIcon.vue?vue&type=template&id=89b81d64&"
import script from "./StarSolidTopBarIcon.vue?vue&type=script&lang=js&"
export * from "./StarSolidTopBarIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports